import { render, staticRenderFns } from "./stats-card.vue?vue&type=template&id=75bc9d4e&scoped=true&"
import script from "./stats-card.vue?vue&type=script&lang=js&"
export * from "./stats-card.vue?vue&type=script&lang=js&"
import style0 from "./stats-card.vue?vue&type=style&index=0&id=75bc9d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bc9d4e",
  null
  
)

export default component.exports